import React from "react";

const NeueAttachmentRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.72 3H5.92C4.85961 3 4 3.86455 4 4.93103V15.069C4 16.1355 4.85961 17 5.92 17H14.08C15.1404 17 16 16.1355 16 15.069V8.31034M10.72 3V6.37931C10.72 7.44579 11.5796 8.31034 12.64 8.31034H16M10.72 3L16 8.31034",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueAttachmentRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;